import { render, staticRenderFns } from "./ProcedureTable.vue?vue&type=template&id=28f00841&scoped=true"
import script from "./ProcedureTable.vue?vue&type=script&lang=js"
export * from "./ProcedureTable.vue?vue&type=script&lang=js"
import style0 from "./ProcedureTable.vue?vue&type=style&index=0&id=28f00841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f00841",
  null
  
)

export default component.exports